import { ApiRoutes } from "../common/apiRoutes";
import Http from "../services/http";

export const getProfileAPI = () => {
  return Http.get(ApiRoutes.profile);
};
export const updateProfileAPI = (data:any) => {
  return Http.post(ApiRoutes.updateProfile,data);
};
export const changePasswordAPI = (data:any) => {
  return Http.post(ApiRoutes.changePassword,data);
};